import React, { useState, useContext, useEffect } from "react";
import "../css/Login.css";
import cubix_logo from "../img/cubix_logo.png";


import axios from "axios";
import LoadingLayout from "./LoadingLayout";



import { useNavigate } from "react-router-dom";
import "../css/CommonStyle.css";
import ic_success from "../img/ic_success.png";

import ic_sad_cloud from "../img/ic_sad_cloud.png";

import logo from "../img/autoland_logo_original.png";

function CustomerRegistration() {

    const [errorMessage, setErrorMessage] = useState()
    const [showSuccessPopup, setShowSuccessPopup] = useState(false)
    const [showFailurePopup, setShowFailurePopup] = useState(false)
    const [failuremessage, setFailuremessage] = useState("")
    const [showLoading, setShowLoading] = useState(false)

    const objectToSend = [
        {
            slno: "",
            cust_name: "",
            password_set_by_customer: "",
            company_name: "",
            phone_number: "",
            email_id: "",
            type_of_business: ""
        }
    ]

    const [arrayToSendToAPI, setArrayToSendToAPI] = useState(objectToSend)

    const navigate = useNavigate();


    const [loadingScreenLoginState, setLoadingScreenLoginState] = useState(false);
    const [loadingScreenState, setLoadingScreenState] = useState(false);



    const handleInputChange = (e) => {

        console.log("e received ", e.target.name, e.target.value)

        let newObject = { ...arrayToSendToAPI[0], [e.target.name]: e.target.value }

        console.log("newobject ", newObject)

        let newobjecToSave = { ...arrayToSendToAPI[0], [e.target.name]: e.target.value }

        setArrayToSendToAPI([newobjecToSave]);
    };


    useEffect(() => {



    }, [])

    const callSendingAPI = () => {

        setShowLoading(true);

        let apiUrl = "https://cubixweberp.com:197/api/partnerrequest"

        axios.post(apiUrl, arrayToSendToAPI).then((res) => {

            setShowLoading(false);

            console.log("res", res)

            setShowSuccessPopup(true)

        }).catch((err) => {
            setShowLoading(false);
        })

    }

    const clickedOnJoinButton = async () => {

        setShowLoading(true);

        console.log("clicked on register ", arrayToSendToAPI)

        let isDuplicate = await checkIfCompanyNameAlreadyExists();

        setShowLoading(false);

        if (isDuplicate) {

            setShowFailurePopup(true)
            setFailuremessage("this username name is already taken")
        }
        else if (isDuplicate == null) {
            setShowFailurePopup(true)
            setFailuremessage("Something went wrong please try later")
        }
        else {
            callSendingAPI()
        }

    }

    const checkIfCompanyNameAlreadyExists = async () => {

        return new Promise((resolve, reject) => {

            let apiUrl = `https://cubixweberp.com:197/api/partnerrequest/checkexist/${arrayToSendToAPI[0].cust_name}`

            axios.get(apiUrl).then((res) => {

                console.log("res is ", res)

                if (res.data[0].column1 == 0) {
                    resolve(false)
                } else {
                    resolve(true)
                }
            }).catch((err) => {
                console.log("err is ", err)
                resolve(null)
            })
        })

    }

    return (
        <div className="Login-page-height">

            <div className="container">

                <div className="Login-logo-container">
                    <a className="logo-container Header-logo p-2">
                        <img style={{ width: "200px", margin: "20px" }} src={logo} alt="logo" />

                    </a>
                </div>

                <div className="Login-main-section">

                    <div className="LoginNew-Section">

                        <div className="Login-Main-center-content">

                            <span>
                                <div className="LoginNew-Form-Content">

                                    <h4 className="Join_partner_program_Text">
                                        Customer Registration <br />

                                    </h4>

                                    <h6 className="Join_partner_program_Text_sub_heading ">Please Enter the details and register, and our team will get back to you</h6>

                                    <form className="Join_partner_program_form">
                                        <input
                                            type="text"
                                            name="cust_name"
                                            placeholder="User Id"
                                            value={arrayToSendToAPI[0]?.cust_name}
                                            onChange={handleInputChange}
                                            className="LoginNew-Input mt-3"
                                        />
                                        <input
                                            type="text"
                                            name="password_set_by_customer"
                                            placeholder="Set a password"
                                            value={arrayToSendToAPI[0]?.password_set_by_customer}
                                            onChange={handleInputChange}
                                            className="LoginNew-Input mt-3"
                                        />
                                        <input
                                            type="text"
                                            name="company_name"
                                            placeholder="Company name"
                                            value={arrayToSendToAPI[0]?.company_name}
                                            onChange={handleInputChange}
                                            className="LoginNew-Input mt-3"
                                        />

                                        <input
                                            type="text"
                                            name="phone_number"
                                            placeholder="Phone number"
                                            value={arrayToSendToAPI[0]?.phone_number}
                                            onChange={handleInputChange}
                                            className="LoginNew-Input mt-3"
                                        />
                                        <input
                                            type="text"
                                            name="email_id"
                                            placeholder="Email id"
                                            value={arrayToSendToAPI[0]?.email_id}
                                            onChange={handleInputChange}
                                            className="LoginNew-Input mt-3"
                                        />

                                        <div className="mt-4">
                                            <span>
                                                <input type="radio" id="retail" name="type_of_business" value="retail" onChange={handleInputChange} />
                                                <label for="retail" className="ms-1">Retail</label>
                                            </span>
                                            <span className="ms-3">
                                                <input type="radio" id="wholesale" name="type_of_business" value="wholesale" onChange={handleInputChange} />
                                                <label for="wholesale" className="ms-1">Wholesale</label>
                                            </span>
                                            <span className="ms-3">
                                                <input type="radio" id="fleet" name="type_of_business" value="fleet" onChange={handleInputChange} />
                                                <label for="fleet" className="ms-1">Fleet</label>
                                            </span>
                                        </div>
                                        <input
                                            type="button"
                                            value="Register"
                                            className="btn btn-sm mt-4"
                                            style={{ backgroundColor: "#26648c", color: "#ffffff" }}
                                            onClick={clickedOnJoinButton}
                                        />
                                        <label className="Login-form-error-label">{errorMessage}</label>
                                    </form>

                                    <span>
                                        <div className="d-flex align-items-center">
                                            Already have account
                                            <button className="btn btn-sm btn-dark ms-3" onClick={() => navigate("/")}>Login Now</button>
                                        </div>
                                    </span>

                                </div>
                            </span>

                        </div>

                    </div>

                </div>

            </div>



            <div className="Login-bottom-strip-content d-flex justify-content-end">
                {" "}
                <span>powered by </span>
                <img alt="placeholder" src={cubix_logo} />
            </div>


            {loadingScreenState &&
                <LoadingLayout message={{ messageFromScreen: "Checking Log Status" }} />
            }

            {
                loadingScreenLoginState &&
                <LoadingLayout message={{ messageFromScreen: "Checking input values" }} />
            }


            {
                showSuccessPopup &&
                <div className="popup_outer">
                    <div className="popup_inner p-4">
                        <h3><img src={ic_success} className="popup_icon me-2" />Registration Success</h3>
                        <div className="d-flex justify-content-end">
                            <button className="btn btn-sm btn-primary" onClick={() => setShowSuccessPopup(false)}>Close</button>
                        </div>
                    </div>
                </div>
            }

            {
                showFailurePopup &&
                <div className="popup_outer">
                    <div className="popup_inner p-4">
                        <h3><img src={ic_sad_cloud} className="popup_icon me-2" />{failuremessage}</h3>
                        <div className="d-flex justify-content-end">
                            <button className="btn btn-sm btn-primary" onClick={() => setShowFailurePopup(false)}>Close</button>
                        </div>
                    </div>
                </div>
            }

            {
                showLoading &&
                <div className="popup_outer">
                    <div className="popup_inner p-4 d-flex flex-column align-items-center">

                        <div class="spinner-border text-primary" role="status">

                        </div>
                        <h3>Please wait...</h3>

                    </div>
                </div>

            }


        </div>
    );
}

export default CustomerRegistration;
